import React from "react";
import { TextAreaProps } from "./models";
import { Wrapper, InputStyled, ErrorMessage } from "./styles";

const TextArea = React.forwardRef<HTMLInputElement, TextAreaProps>(
  ({ label, filled, errorMessage, ...props }, ref) => {
    return (
      <Wrapper>
        <InputStyled
          {...props}
          multiline
          label={label}
          inputRef={ref}
          filled={filled}
          error={!!errorMessage}
        />
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </Wrapper>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
